/*
 * GENERATED FILE - DO NOT EDIT.
 * Regenerate with: pnpm --filter @thw/web permissions:generate
 * Source: apps/api/src/platform/kernel/authorization-grant.ts (PERMISSION_CODES)
 */

/**
 * The backend authorization vocabulary, mirrored for the web shell so a
 * client build fails closed (via the `--check` staleness gate) rather than
 * silently diverging from the API. This is the ONLY permission-code list in
 * the web client; nothing here is hand-maintained.
 */
export const PERMISSION_CODES = [
  "account_read",
  "account_create",
  "account_activate",
  "account_suspend",
  "account_deactivate",
  "grant_read",
  "grant_manage",
  "session_revoke_all",
  "organization_read",
  "organization_propose",
  "organization_approve",
  "jurisdiction_boundary_read",
  "jurisdiction_boundary_propose",
  "jurisdiction_boundary_approve",
  "configuration_propose",
  "configuration_review",
  "configuration_activate",
  "configuration_retire",
  "person_read",
  "person_manage_basic",
  "personnel_assign_luk_staff",
  "personnel_assignment_manage",
  "qualification_read",
  "qualification_manage",
  "qualification_catalogue_edit",
  "qualification_catalogue_approve",
  "qualification_record_write",
  "roster_read",
  "stan_catalogue_read",
  "stan_catalogue_propose",
  "stan_catalogue_review",
  "stan_catalogue_owner_approve",
  "stan_catalogue_activate",
  "stan_module_instance_manage",
  "asset_read",
  "asset_manage",
  "terminology_catalogue_read",
  "terminology_catalogue_manage",
  "terminology_catalogue_activate",
  "terminology_catalogue_archive",
  "readiness_read",
  "readiness_decide_manual",
  "mission_read",
  "mission_create",
  "mission_activate",
  "mission_close",
  "command_structure_read",
  "command_change_propose",
  "command_change_review",
  "command_structure_manage",
  "command_action_grant_manage",
  "command_action_execute",
  "field_task_read_own",
  "field_task_read_unit",
  "field_task_assign",
  "field_task_deliver",
  "field_task_cancel",
  "field_task_execute",
  "external_authority_read",
  "external_authority_manage",
  "damage_event_read",
  "damage_event_manage",
  "assistance_request_read",
  "assistance_request_register",
  "assistance_request_review",
  "assistance_request_decide",
  "adviser_assignment_read",
  "adviser_assignment_assign",
  "adviser_assignment_manage",
  "field_assessment_edit",
  "field_assessment_submit",
  "assessment_review",
  "requirement_propose",
  "requirement_review",
  "requirement_read",
  "incident_reference_read",
  "incident_reference_propose",
  "incident_reference_review",
  "incident_reference_activate",
  "incident_reference_retire",
  "request_create",
  "request_review",
  "request_escalate",
  "availability_respond",
  "resource_commit",
  "resource_allocate",
  "resource_release",
  "luk_activate",
  "luk_staff",
  "luk_work_manage",
  "luk_deactivate",
  "order_read",
  "order_create",
  "order_issue",
  "order_delivery_record",
  "order_acknowledge",
  "order_personal_acknowledge",
  "order_complete",
  "order_cancel",
  "order_authorize_deployment",
  "travel_authorization_decide",
  "form_read",
  "form_create",
  "form_approve",
  "form_submit",
  "form_route",
  "form_acknowledge",
  "form_template_read",
  "form_template_propose",
  "form_template_review",
  "form_template_approve",
  "form_template_activate",
  "form_template_retire",
  "registration_submit",
  "registration_approve",
  "registration_apply",
  "registration_overview_read",
  "registration_movement_record",
  "logistics_request_read",
  "logistics_request_create",
  "logistics_request_process",
  "logistics_delivery_manage",
  "logistics_receipt_confirm",
  "document_upload",
  "document_review",
  "document_release",
  "document_download",
  "quarantine_review",
  "map_reference_propose",
  "map_reference_approve",
  "map_object_read",
  "map_object_create",
  "map_object_review",
  "map_object_publish",
  "icon_catalog_read",
  "icon_catalog_manage",
  "icon_catalog_publish",
  "icon_catalog_archive",
  "icon_catalog_audit",
  "report_generate",
  "report_view",
  "report_export",
  "report_template_manage",
  "after_action_review_read",
  "after_action_review_manage",
  "after_action_review_approve",
  "notification_read",
  "notification_acknowledge",
  "notification_rule_manage",
  "notification_escalation_manage",
  "recurring_check_manage",
  "recurring_check_read",
  "hazard_assessment_record",
  "hazard_assessment_read",
  "situation_report_create",
  "situation_report_read",
  "alert_campaign_create",
  "alert_campaign_read",
  "channel_read",
  "channel_manage",
  "message_send",
  "message_edit_own",
  "message_redact",
  "voice_message_send",
  "etb_promotion_propose",
  "etb_promotion_review",
  "etb_entry_append",
  "etb_entry_correct",
  "speech_use",
  "speech_configure",
  "audit_read",
  "security_operate",
  "retention_policy_manage",
  "legal_hold_manage",
  "manual_disposition_execute",
  "backup_operate",
  "restore_test_execute",
  "offline_manifest_propose",
  "offline_manifest_approve",
  "offline_map_use",
  "offline_form_use",
  "offline_diary_draft_use",
  "offline_sync",
  "integration_operate",
  "thwiki_extraction_run",
  "thwiki_candidate_read",
  "thwiki_candidate_edit",
  "thwiki_candidate_review",
  "thwiki_candidate_bulk_review",
  "thwiki_import_preview",
  "thwiki_import_execute",
  "thwiki_source_config_manage",
] as const;

export type PermissionCode = (typeof PERMISSION_CODES)[number];

export const PERMISSION_CODE_SET: ReadonlySet<PermissionCode> = new Set(
  PERMISSION_CODES,
);
